function initProductGalleryThumbnails() {
  const thumbnails = document.querySelectorAll('.product-gallery__thumbnail');
  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const mediaId = this.getAttribute('data-media-id');
      document.querySelectorAll('.product-gallery__thumbnail').forEach(function (t) {
        t.classList.remove('is-nav-selected');
      });
      this.classList.add('is-nav-selected');
      document.querySelectorAll('.product-gallery__carousel-item').forEach(function (item) {
        item.classList.remove('is-selected');
      });
      const selectedItem = document.querySelector('.product-gallery__carousel-item[data-media-id="' + mediaId + '"]');
      if (selectedItem) {
        selectedItem.classList.add('is-selected');
        const carousel = document.querySelector('.product-gallery__carousel');
        const flickityViewport = carousel && carousel.querySelector('.flickity-viewport');
        if (flickityViewport) {
          flickityViewport.style.height = selectedItem.offsetHeight + 'px';
        }
      }
    });
  });
}

function initQuantityPriceUpdates() {
  const quantityInput = document.querySelector('input[name="quantity"]');
  const priceBox = document.getElementById('PriceList');

  if (!quantityInput || !priceBox) return;

  const priceSpan = priceBox.querySelector('.js-price');
  const compareSpan = priceBox.querySelector('.js-compare-price');

  if (!priceSpan || !compareSpan) return;

  const basePrice = parseFloat(priceBox.dataset.price);
  const baseCompare = parseFloat(priceBox.dataset.compare);

  function formatMoney(amount) {
    return `$${amount.toFixed(2)}`;
  }

  function updatePrices() {
    const qty = parseInt(quantityInput.value, 10) || 1;
    const totalPrice = basePrice * qty;
    const totalCompare = baseCompare * qty;

    priceSpan.textContent = formatMoney(totalPrice);

    if (compareSpan && baseCompare > basePrice) {
      compareSpan.textContent = formatMoney(totalCompare);
    }
  }

  quantityInput.addEventListener('input', updatePrices);

  const buttons = document.querySelectorAll(
    '[data-action="increase-picker-quantity"], [data-action="decrease-picker-quantity"]'
  );
  buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      setTimeout(updatePrices, 50);
    });
  });
}

function initExpandableContentToggle() {
  const button = document.querySelector('.expandable-content__toggle');
  if (!button) return;

  button.addEventListener('click', function () {
    const content = document.querySelector('.ui-accordion-content-active');
    if (content) {
      content.style.display = content.style.display === 'block' ? 'none' : 'block';
    }
  });
}

function initMobileStickyAtc() {
  const isMobile = window.matchMedia('(max-width: 630px)');

  if (!isMobile.matches) return;

  const sourceBlock = document.querySelector('.product-info__block-item--buy-buttons');
  if (!sourceBlock) return;

  const sourceButtons = sourceBlock.querySelector('.new-class') || sourceBlock;
  const mainAtcButton = sourceBlock.querySelector('[data-action="add-to-cart"]');

  if (!sourceButtons || !mainAtcButton) return;

  const stickyRoot = document.createElement('div');
  stickyRoot.className = 'mobile-sticky-atc';

  stickyRoot.innerHTML = '<div class="mobile-sticky-atc__inner"></div>';

  const stickyInner = stickyRoot.querySelector('.mobile-sticky-atc__inner');
  const clonedButtons = sourceButtons.cloneNode(true);
  let isAutoScrollingToSource = false;
  let scrollSafetyTimeoutId = null;

  clonedButtons.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));

  const updateStickyState = function (showSticky) {
    const isVisible = stickyRoot.classList.contains('is-visible');
    if (showSticky === isVisible) return;

    stickyRoot.classList.toggle('is-visible', showSticky);
  };

  const syncStickyStateWithViewport = function () {
    const sourceBottomPosition = sourceBlock.getBoundingClientRect().bottom + window.scrollY;
    updateStickyState(window.scrollY > sourceBottomPosition);
  };

  const releaseAutoScrollLock = function () {
    isAutoScrollingToSource = false;
    scrollSafetyTimeoutId = null;
    syncStickyStateWithViewport();
  };

  const clonedAtcButton = clonedButtons.querySelector('[data-action="add-to-cart"]');
  const productForm = document.querySelector('form[action*="/cart/add"]');
  if (clonedAtcButton) {
    clonedAtcButton.type = 'button';
    clonedAtcButton.addEventListener('click', function (e) {
      e.preventDefault();
      if (isAutoScrollingToSource) return;

      isAutoScrollingToSource = true;
      updateStickyState(false);

      if (scrollSafetyTimeoutId) window.clearTimeout(scrollSafetyTimeoutId);
      scrollSafetyTimeoutId = window.setTimeout(releaseAutoScrollLock, 700);

      sourceBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => {
        if (!productForm) return;
        const isValid = productForm.reportValidity();
        if (!isValid) return;
        productForm.submit();
      }, 500);
    });
  }

  stickyInner.appendChild(clonedButtons);
  document.body.appendChild(stickyRoot);

  let isSyncScheduled = false;
  const scheduleStickySync = function () {
    if (isSyncScheduled) return;
    isSyncScheduled = true;

    window.requestAnimationFrame(function () {
      isSyncScheduled = false;
      if (isAutoScrollingToSource) return;
      syncStickyStateWithViewport();
    });
  };

  window.addEventListener('scroll', scheduleStickySync, { passive: true });

  window.addEventListener('resize', () => {
    if (!isMobile.matches) {
      updateStickyState(false);
    } else {
      scheduleStickySync();
    }
  });

  scheduleStickySync();
}

document.addEventListener('DOMContentLoaded', function () {
  initProductGalleryThumbnails();
  initQuantityPriceUpdates();
  initExpandableContentToggle();
  initMobileStickyAtc();
});
